export default {
    probeunit: {
            unit: 'Unit',
            unitMark: 'Unit Mark',
            unitMeasurement: 'Measurement Unit',
            uOMAlreadyExists: 'Measurement Unit already exists.',
            unitTagAlreadyExists: 'Unit Mark already exists.',
            unitNumber: 'Unit ID',
            unitNumberAlreadyExists: 'Unit ID already exists.',
            describe: 'Description',
            operation:"Actions",
            uOMCannotBeBlank: 'Measurement Unit is required.',
            unitCannotBeBlank: 'Unit is required.',
            unitNumberCannotBeBlank: 'Unit ID is required.',
            table_unit_mark: 'Unit Mark',
            table_unit_number: 'Unit ID',

    }
}